const AuctionSkeleton = () => {
  return (
    <div className="h-[440px] min-w-[320px] flex flex-col justify-between  animate-pulse rounded bg-dark-900 overflow-hidden transition-all shadow-md ">
      <div className='flex-col'>
        <div className="flex justify-between pt-2 px-2 h-[125px] bg-dark-700">
          <div className="w-20 h-3 mt-1 rounded bg-dark-800" />
          <div />
          <div className="w-20 h-5 rounded bg-dark-800" />
        </div>
        <div className="flex-col items-center space-y-3 bg-dark-900">

          <div className="flex items-center justify-between">
            <div className="h-5 w-[40%] rounded bg-dark-700 mt-3 mx-2" />
            <div className="flex items-center justify-end gap-1.5 w-[45%] mt-3 mx-2">
              <div className="w-5 h-5 rounded-full bg-dark-700" />
              <div className="h-5 w-[55%] rounded bg-dark-700" />
            </div>

          </div>
          <div className='flex items-center justify-between mx-2'>
            <div className='flex gap-2.5'>
              <div className="w-5 h-5 rounded-full bg-dark-700" />
              <div className="w-5 h-5 rounded-full bg-dark-700" />
              <div className="w-5 h-5 rounded-full bg-dark-700" />
              <div className="w-5 h-5 rounded-full bg-dark-700" />
              <div className="w-5 h-5 rounded-full bg-dark-700" />
              <div className="w-5 h-5 rounded-full bg-dark-700" />
            </div>
            <div className="h-4 w-[30%] rounded bg-dark-700" />
          </div>
        </div>
      </div>
      <div className="flex-col justify-between space-y-10 px-2 h-[152px]">
        <div className="flex justify-between">
          <div className="w-[40%] h-2 rounded bg-dark-800" />
          <div className="w-[40%] h-2 rounded bg-dark-800" />
        </div>
        <div className='flex justify-between w-full'>
          <div className="flex flex-col items-start w-[35%] gap-2">
            <div className="w-full h-1 rounded bg-dark-800" />
            <div className="w-[85%] h-3 rounded bg-dark-700" />
          </div>
          <div className="flex flex-col items-end w-[35%] gap-2">
            <div className="w-full h-1 rounded bg-dark-800" />
            <div className="w-[85%] h-3 rounded bg-dark-700" />
          </div>
        </div>
        <div className="flex-col w-full">
          <div className="flex justify-between">
            <div className="w-24 h-2 rounded bg-dark-700" />
            <div className="w-10 h-2 rounded bg-dark-700" />
          </div>
          <div className="w-full h-2 mt-2 rounded bg-dark-700" />
        </div>
      </div>
      <div className="w-[95%] h-10 mx-auto mb-2.5 rounded bg-dark-700" />
    </div>
  )
}

export default AuctionSkeleton
